import { PassengerType } from "@b2bportal/core-types";
import dayjs from "dayjs";

export const getPassengerType = ({
  dateOfBirth,
  tripDate,
}: {
  dateOfBirth: string;
  tripDate?: string | Date;
}): PassengerType => {
  const referenceDate = tripDate != null ? dayjs(tripDate) : dayjs();
  const age = referenceDate.diff(dayjs(dateOfBirth, "YYYY-MM-DD"), "year");
  if (age > 11) {
    return PassengerType.Adult;
  } else if (age >= 2) {
    return PassengerType.Child;
  } else if (age > 1) {
    return PassengerType.InfantInSeat;
  } else {
    return PassengerType.InfantInLap;
  }
};
